<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      show: true
    }
  },
  watch: {
    '$page.props.flash': {
      handler(flash) {
        if (flash.success) {
          this.$swal.fire({
            icon: 'success',
            title: flash.success,
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          });
        }

        if (flash.error) {
          this.$swal.fire({
            icon: 'error',
            title: flash.error,
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          });
        }

        if (Object.keys(this.$page.props.errors).length > 0) {
          const errorMessages = Object.values(this.$page.props.errors).flat();
          this.$swal.fire({
            icon: 'error',
            title: 'Error en el formulario',
            text: errorMessages.join('\n'),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          });
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
